/* Clipboard */
export const INIT_COPY = 'INIT_COPY';
export const INIT_COPY_SUCCESS = 'INIT_COPY_SUCCESS';
export const INIT_COPY_FAILED = 'INIT_COPY_FAILED';
export const CREATE_COPY_BUTTON = 'CREATE_COPY_BUTTON';
export const CREATE_COPY_BUTTON_SUCCESS = 'CREATE_COPY_BUTTON_SUCCESS';
export const CREATE_COPY_BUTTON_FAILED = 'CREATE_COPY_BUTTON_FAILED';

/* Disqus */
export const LOAD_DISQUS_SCRIPT = 'LOAD_DISQUS_SCRIPT';
export const LOAD_DISQUS_SCRIPT_SUCCESS = 'LOAD_DISQUS_SCRIPT_SUCCESS';
export const LOAD_DISQUS_SCRIPT_FAILED = 'LOAD_DISQUS_SCRIPT_FAILED';
export const INIT_DISQUS_CONFIG = 'INIT_DISQUS_CONFIG';
export const INIT_DISQUS_CONFIG_SUCCESS = 'INIT_DISQUS_CONFIG_SUCCESS';
export const INIT_DISQUS_CONFIG_FAILED = 'INIT_DISQUS_CONFIG_FAILED';

/* Twitter */
export const RENDER_TWEETS = 'RENDER_TWEETS';
export const RENDER_TWEETS_SUCCESS = 'RENDER_TWEETS_SUCCESS';
export const RENDER_TWEETS_FAILED = 'RENDER_TWEETS_FAILED';

/* Components */
export const RENDER_COMPONENTS = 'RENDER_COMPONENTS';
export const RENDER_COMPONENTS_SUCCESS = 'RENDER_COMPONENTS_SUCCESS';
export const RENDER_COMPONENTS_FAILED = 'RENDER_COMPONENTS_FAILED';
